import {
  HomeIcon,
  CalendarDaysIcon,
  BookOpenIcon,
  FolderOpenIcon,
  DocumentTextIcon,
  ChartBarIcon,
  CurrencyDollarIcon,
  TableCellsIcon,
  ServerStackIcon,
  MicrophoneIcon,
  AcademicCapIcon,
  TrophyIcon,
  QuestionMarkCircleIcon,
  GlobeAltIcon,
  UsersIcon,
  PresentationChartLineIcon,
  Cog6ToothIcon,
  DocumentIcon,
  ClipboardDocumentListIcon,
  UserGroupIcon,
  BuildingOfficeIcon,
  EnvelopeIcon,
  TagIcon,
  WrenchScrewdriverIcon,
  ChartPieIcon,
  LinkIcon,
} from "@heroicons/react/24/outline";
import { Route, GraduationCap } from "lucide-react";

// Map icon names to actual icon components
// This allows us to serialize icon references in localStorage
export const iconMap: Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  HomeIcon,
  CalendarDaysIcon,
  BookOpenIcon,
  FolderOpenIcon,
  DocumentTextIcon,
  ChartBarIcon,
  CurrencyDollarIcon,
  TableCellsIcon,
  ServerStackIcon,
  MicrophoneIcon,
  AcademicCapIcon,
  TrophyIcon,
  QuestionMarkCircleIcon,
  GlobeAltIcon,
  UsersIcon,
  PresentationChartLineIcon,
  Cog6ToothIcon,
  DocumentIcon,
  ClipboardDocumentListIcon,
  UserGroupIcon,
  BuildingOfficeIcon,
  EnvelopeIcon,
  TagIcon,
  WrenchScrewdriverIcon,
  ChartPieIcon,
  LinkIcon,
  // Lucide icons
  Route: Route as unknown as React.ComponentType<React.SVGProps<SVGSVGElement>>,
  GraduationCap: GraduationCap as unknown as React.ComponentType<React.SVGProps<SVGSVGElement>>,
};

// Get icon component by name, with fallback
export const getIconByName = (name: string): React.ComponentType<React.SVGProps<SVGSVGElement>> => {
  return iconMap[name] || LinkIcon;
};

// Get icon name from component (for initial mapping)
export const getIconName = (icon: React.ComponentType<React.SVGProps<SVGSVGElement>>): string => {
  // Try to match by comparing function references
  for (const [name, component] of Object.entries(iconMap)) {
    if (component === icon) {
      return name;
    }
  }

  // Try to get displayName or name
  const iconWithName = icon as { displayName?: string; name?: string };
  if (iconWithName.displayName) {
    return iconWithName.displayName;
  }
  if (iconWithName.name) {
    return iconWithName.name;
  }

  return 'LinkIcon';
};
